/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/JourneysListPageQuery$parameters.ts';
import type { JourneysListPageQuery } from './__generated__/JourneysListPageQuery.graphql.ts';

const JOURNEYS_LIST_FIELD_SET_IDS = [
	'issuetype',
	'issuekey',
	'summary',
	'status',
	'assignee',
	'created',
	'duedate',
];

type Queries = {
	tableQueryRef: JourneysListPageQuery;
};

type JourneysListEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const journeysListEntryPoint: EntryPoint<
	JourneysListEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<JourneysListEntryPointComponent>(
		/* eslint-disable-next-line @atlassian/react-entrypoint/entrypoint-root-module-path */
		/* webpackChunkName: "async-journeys-list", jiraSpaEntry: "async-journeys-list" */ './JourneysListPage.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			tableQueryRef: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					issueSearchInput: {
						jql: `project = ${
							context.match.params.projectKey || ''
						} AND journeyParentOfTypeId IS NOT EMPTY ORDER BY created DESC`,
					},
					first: 50,
					fieldSetsInput: {
						fieldSetIds: JOURNEYS_LIST_FIELD_SET_IDS,
					},
					fieldSetIds: JOURNEYS_LIST_FIELD_SET_IDS,
				},
			},
		},
		entryPoints: {},
		extraProps: {},
	}),
});
